import type { PersonRole } from '@cugumi/shared/types'
import { cn } from '@/lib/cn'
import styles from './RoleSelector.module.css'

interface RoleSelectorProps {
  selected: PersonRole
  onChange: (role: PersonRole) => void
  hasGroom: boolean
  hasBride: boolean
}

const ROLES: { value: PersonRole; label: string }[] = [
  { value: 'COUPLE', label: '커플' },
  { value: 'GROOM', label: '신랑' },
  { value: 'BRIDE', label: '신부' },
]

export function RoleSelector({ selected, onChange, hasGroom, hasBride }: RoleSelectorProps) {
  const isDisabled = (role: PersonRole) => {
    if (role === 'COUPLE') return !hasGroom || !hasBride
    if (role === 'GROOM') return !hasGroom
    if (role === 'BRIDE') return !hasBride
    return false
  }

  return (
    <div className={styles.container}>
      {ROLES.map(({ value, label }) => {
        const disabled = isDisabled(value)
        return (
          <button
            key={value}
            type="button"
            className={cn(styles.option, selected === value && styles.selected)}
            onClick={() => onChange(value)}
            disabled={disabled}
            style={disabled ? { opacity: 0.4, cursor: 'not-allowed' } : undefined}
          >
            <span className={cn(styles.radio, selected === value && styles.radioSelected)} />
            {label}
          </button>
        )
      })}
    </div>
  )
}
